export default {
    // Root State
    mutations: {
        SET_STORE: "setStore",
        SET_STORE_CONTRACT: "setStoreContract",
        SET_AREA_LIST: "setAreaList",
        SET_VACANCY_AREA_LIST: "setVacancyAreaList",
        SET_FACILITY_VACANCY_LIST: "setFacilityVacancyList",
    },
    actions: {
        SETUP: "setup",
        LOOP: "loop",
    },
};
